/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyBoxIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-box" */ './utils').then((m) => m.BoxIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/box/icon' },
);

const LazyBoxSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-box-search-result" */ './utils').then(
			(m) => m.BoxSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/box/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const BoxIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyBoxIconComponent />
	</Suspense>
);

export const BoxSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyBoxSearchResultIconComponent />
	</Suspense>
);
